module.exports = __webpack_public_path__ + "img/cases-brand-suning-0.1309fb90.jpg";